import * as React from "react";
const SvgFiRrDrum = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-drum_svg__a)">
      <path
        fill="#062147"
        d="M22.499 6.285a1 1 0 1 0-1.398 1.43c.597.583.899 1.184.899 1.785 0 2.129-4.106 4.5-10 4.5S2 11.629 2 9.5 6.106 5 12 5c.641 0 1.283.029 1.908.087a.99.99 0 0 0 1.088-.904 1 1 0 0 0-.904-1.088A23 23 0 0 0 12 3C5.271 3 0 5.855 0 9.5v8C0 21.145 5.271 24 12 24s12-2.855 12-6.5v-8c0-1.144-.52-2.256-1.501-3.215M11 21.976a18.4 18.4 0 0 1-4-.611v-5.936c1.23.298 2.576.488 4 .549zm2-5.998a21 21 0 0 0 4-.549v5.936a18.4 18.4 0 0 1-4 .611zM2 17.5v-4.361c.802.654 1.819 1.22 3 1.673v5.835c-1.891-.87-3-2.042-3-3.147m17 3.147v-5.835c1.181-.453 2.198-1.019 3-1.673V17.5c0 1.106-1.109 2.277-3 3.147M12.293 9.255 22.306.256a1.002 1.002 0 0 1 1.338 1.488l-10.013 9a1.002 1.002 0 0 1-1.338-1.49"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-drum_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDrum;
